<template>
		<div id='captura'>
		<div name='contrato-ver' v-if='contratoSolo !=null'>
			<table align="center" v-for="contratos in contratoSolo">
				<tr>
				<td>familia:</td>
				<td>{{contratos.familia}}</td>
				</tr>
				<tr>
				<td>subfamilia:</td>
				<td>{{contratos.subfamilia}}</td>
				</tr>
				<tr>
				<td>dueño:</td>
				<td>{{contratos.dueno}}</td>
				</tr>				
				<tr>
				<td>Contrato Número:</td>
				<td>{{contratos.id}}</td>
				</tr>
				<tr>
				<td>propiedad:</td>
				<td>{{contratos.propiedad}}</td>
				</tr>
				<tr>
				<td>propiedad Num:</td>
				<td>{{contratos.propiedadId}}</td>
				</tr>
				<tr>
				<td>inquilino:</td>
				<td>{{contratos.inquilino}}</td>
				</tr>
				<tr>
				<td>inquilino Num:</td>
				<td>{{contratos.inquilinoId}}</td>
				</tr>
				<tr>
				<td>nombreComercial:</td>
				<td>{{contratos.nombreComercial}}</td>
				</tr>
				<tr>
				<td>giro:</td>
				<td>{{contratos.giro}}</td>
				</tr>
				<tr>
				<td>importeMes:</td>
				<td>$ {{formateaNumero(contratos.importeMes)}}</td>
				</tr>
				<tr>
				<td>fecha Inicio:</td>
				<td>{{formateaFecha(contratos.fechaInicio)}}</td>
				</tr>
				<tr>
				<td>fecha Terminacion:</td>
				<td>{{formateaFecha(contratos.fechaTerminacion)}}</td>
				</tr>				
				<tr>
				<td>quien Modifico:</td>
				<td>{{contratos.quienModifico}}</td>
				</tr>
				<tr>
				<td>status:</td>
				<td>{{contratos.status}}</td>
				</tr>
				<tr>
				<td>area:</td>
				<td>{{contratos.area}}</td>
				</tr>
				<tr>
				<td>medidas:</td>
				<td>{{contratos.medidasYcol}}</td>
				</tr>
				<tr>
				<td>finalizo:</td>
				<td>{{contratos.finalizo}}</td>
				</tr>
				<tr>
				<td>direccion inquilino:</td>
				<td>{{contratos.dirInquilino}}</td>
				</tr>		
				<tr>
				<td>celular inquilino:</td>
				<td>{{contratos.celularInquilino}}</td>
				</tr>						
				<tr>
				<td>mail inquilino:</td>
				<td>{{contratos.emailInquilino}}</td>
				</tr>
				<tr>
				<td>facebook inquilino:</td>
				<td>{{contratos.fbInquilino}}</td>
				</tr>
				<tr>
				<td>whatsapp inquilino:</td>
				<td>{{contratos.wappInquilino}}</td>
				</tr>		
				<tr>
				<td>id inquilino:</td>
				<td>{{contratos.idInquilino}}</td>
				</tr>						
				<tr>
				<td>comprobante dom. inquilino:</td>
				<td>{{contratos.comDomInquilino}}</td>
				</tr>
				<tr>
				<td>nombre aval:</td>
				<td>{{contratos.nomAval}}</td>
				</tr>
				<tr>
				<td>direccion aval:</td>
				<td>{{contratos.dirAval}}</td>
				</tr>
				<tr>
				<td>direccion aval:</td>
				<td>{{contratos.direccionAval}}</td>
				</tr>
				<tr>
				<td>mail aval:</td>
				<td>{{contratos.mailAval}}</td>
				</tr>
				<tr>
				<td>celular aval:</td>
				<td>{{contratos.celAval}}</td>
				</tr>
				<tr>
				<td>facebook aval:</td>
				<td>{{contratos.fbAval}}</td>
				</tr>
				<tr>
				<td>id aval:</td>
				<td>{{contratos.ideAval}}</td>
				</tr>
				<tr>
				<td>comprobante aval:</td>
				<td>{{contratos.comDomAval}}</td>
				</tr>


			</table>
			<br>
			<br>



		</div>
		<span v-else>Cargando contrato</span>
	</div>
</template>

<script>

	import axios from 'axios';
	export default{
		name:'contrato-detalle',
		prueba:'funciona',
		mounted(){
			this.entrar();
		},
		props:['vector'],
		data(){
			return{
				id: null,
				contratoSolo: null	
			}
		},
		methods:{
			entrar(){
				// checa si tiene autorizacion
		  		if(!this.vector.includes('MASTERGGUV')){
			  		if(!this.vector.includes('Contratos Ver detalle')){
			  			document.getElementById('captura').hidden = true;
			  			alert('Seccion no autorizada');
			  			return;
			  		}
			  	}
				this.id=this.$route.params.id;				
				axios.get('https://www.directodo.com/Rentus/accesosdb/leeUnContrato.php?id='+this.id)
	  		         .then((respue) => {
	  		     		this.contratoSolo=respue.data;
	  		     		console.log(respue.data);
	  			 	 });
	  		},

			formateaFecha: function (fecha) {
				var d = new Date(fecha); 
				if (Date.parse(d)){
					// pone los minutos de la zona horaria local. Si no lo haces le agrega un dia a la fecha
					d.setMinutes(d.getMinutes() + d.getTimezoneOffset());
					d.setHours(0);
					var opciones = { year: 'numeric', month: 'short', day: 'numeric' };
					d = new Intl.DateTimeFormat('es-mx', opciones).format(d);
					return d} 
				else{return "sin fecha";}
			},

		    formateaNumero(valor1) {
		        return (Number(valor1)).toLocaleString('en-US', {minimumFractionDigits: 2, useGrouping:true});
		    }

		}
	}
</script>

<style lang="scss">
	#contrato-ver{
		padding:20px;
		li{
			width: 30%;
			height: 120px;
			background: #eee;
			overflow: hidden;
		}
	}
</style>


// WEBPACK FOOTER //
// src/Contrato-ver.vue